'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import { keyframes } from '@emotion/react'

// lib
import Box, { BoxProps } from '../../kit/box'

/* -----------------------------------------------------------------------------
 * Skeleton
 *
 * The repo only ships the three-dot `Loading` spinner, which reads poorly for
 * tabular content. This pulses a placeholder block instead.
 * -------------------------------------------------------------------------- */

export type SkeletonProps = BoxProps & {
  height?: number
  width?: number | string
}

// 0.45 to 1 and back, 700ms each way
const pulse = keyframes({
  '0%, 100%': { opacity: 0.45 },
  '50%': { opacity: 1 }
})

function Skeleton({ height = 12, width = '100%', ...otherProps }: SkeletonProps) {
  return (
    <Box
      bg='proDivider'
      borderRadius='proXs'
      height={height}
      style={{ animation: `${pulse} 1400ms ease-in-out infinite` }}
      width={width}
      {...otherProps}
    />
  )
}

export default Skeleton
